module.exports = __webpack_public_path__ + "img/marktgemeinde-nussdorf-debant.5625a859.svg";